needAttach